import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

export function NotFoundPage() {
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="flex-1 flex items-center justify-center px-6 py-24"
    >
      <div className="text-center max-w-lg">
        <p
          className="text-[#004f4f] font-bold text-lg mb-4 tracking-wide uppercase"
          aria-hidden="true"
        >
          Błąd 404
        </p>

        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
          Strona nie&nbsp;istnieje
        </h1>

        <p className="text-slate-600 text-lg leading-relaxed mb-10">
          Strona, której szukasz, mogła zostać usunięta, zmienić adres lub
          nigdy nie istniała. Sprawdź czy adres URL jest poprawny.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-[#004f4f] text-white px-6 py-3 rounded-full hover:bg-[#003d3d] focus:outline-none focus:ring-4 focus:ring-[#004f4f] focus:ring-offset-4 transition-colors font-bold text-base"
          >
            <Home size={18} aria-hidden="true" />
            Strona główna
          </Link>

          <Link
            to="/blog"
            className="inline-flex items-center justify-center gap-2 border-2 border-[#004f4f] text-[#004f4f] px-6 py-3 rounded-full hover:bg-[#004f4f] hover:text-white focus:outline-none focus:ring-4 focus:ring-[#004f4f] focus:ring-offset-4 transition-colors font-bold text-base"
          >
            <ArrowLeft size={18} aria-hidden="true" />
            Wróć do bloga
          </Link>
        </div>
      </div>
    </main>
  );
}
